import i18n from 'live/services/i18n'
import enUs from './i18n/en_us'
import ptBr from './i18n/pt_br'
import './lollipop/index'
import './lollipop/lollipop.scss'
import '../src/histogram/index'
import '../src/histogram/histogram.scss'
import './boxplot/boxplot.scss'
import './boxplot/index'
import './state-timeline/index'
import './state-timeline/state-timeline.scss'
import 'plugin-live-exploratory-viz/src/data-navigation'

const locale = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : 'en_us'
const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])
